import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.some";
import "core-js/modules/es.function.name";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import _createForOfIteratorHelper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module heading/headingcommand
 */
import { Command } from 'ckeditor5/src/core';
import { first } from 'ckeditor5/src/utils';
/**
 * The heading command. It is used by the {@link module:heading/heading~Heading heading feature} to apply headings.
 *
 * @extends module:core/command~Command
 */

var HeadingCommand = /*#__PURE__*/function (_Command) {
  _inherits(HeadingCommand, _Command);

  var _super = _createSuper(HeadingCommand);

  /**
   * Creates an instance of the command.
   *
   * @param {module:core/editor/editor~Editor} editor Editor instance.
   * @param {Array.<String>} modelElements Names of the element which this command can apply in the model.
   */
  function HeadingCommand(editor, modelElements) {
    var _this;

    _classCallCheck(this, HeadingCommand);

    _this = _super.call(this, editor);
    /**
     * If the selection starts in a heading (which {@link #modelElements is supported by this command})
     * the value is set to the name of that heading model element.
     * It is  set to `false` otherwise.
     *
     * @observable
     * @readonly
     * @member {Boolean|String} #value
     */

    /**
     * Set of defined model's elements names that this command support.
     * See {@link module:heading/heading~HeadingOption}.
     *
     * @readonly
     * @member {Array.<String>}
     */

    _this.modelElements = modelElements;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(HeadingCommand, [{
    key: "refresh",
    value: function refresh() {
      var _this2 = this;

      var block = first(this.editor.model.document.selection.getSelectedBlocks());
      this.value = !!block && this.modelElements.includes(block.name) && block.name;
      this.isEnabled = !!block && this.modelElements.some(function (heading) {
        return checkCanBecomeHeading(block, heading, _this2.editor.model.schema);
      });
    }
    /**
     * Executes the command. Applies the heading to the selected blocks or, if the first selected
     * block is a heading already, turns selected headings (of this level only) to paragraphs.
     *
     * @param {Object} options
     * @param {String} options.value Name of the element which this command will apply in the model.
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute(options) {
      var model = this.editor.model;
      var document = model.document;
      var modelElement = options.value;
      model.change(function (writer) {
        var blocks = Array.from(document.selection.getSelectedBlocks()).filter(function (block) {
          return checkCanBecomeHeading(block, modelElement, model.schema);
        });

        var _iterator = _createForOfIteratorHelper(blocks),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var block = _step.value;

            if (!block.is('element', modelElement)) {
              writer.rename(block, modelElement);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }]);

  return HeadingCommand;
}(Command); // Checks whether the given block can be replaced by a specific heading.
//
// @private
// @param {module:engine/model/element~Element} block A block to be tested.
// @param {module:heading/headingcommand~HeadingCommand#modelElement} heading Command element name in the model.
// @param {module:engine/model/schema~Schema} schema The schema of the document.
// @returns {Boolean}


export { HeadingCommand as default };

function checkCanBecomeHeading(block, heading, schema) {
  return schema.checkChild(block.parent, heading) && !schema.isObject(block);
}